import React, {useState} from "react";
import * as ST from "./styled";
import { List } from "@mui/material";
import { ReactComponent as IconNote } from "../../../Assets/note.svg";
import { ReactComponent as IconEvents } from "../../../Assets/calendar-tick.svg";
import { ReactComponent as IconUserSearch } from "../../../Assets/user-search.svg";
import { ReactComponent as IconNotificationStatus } from "../../../Assets/notification-status.svg"; // TODO icon path name
import { ReactComponent as IconLogo } from "../../../Assets/logo-icon.svg";
import MenuAccordion from "../NavigationMenu/MenuAccordion";
import HeaderStore from "../../../Store/HeaderStore";
import Colors from "src/general/constants/colors";

interface BarItem {
	name: string;
	link: string;
	icon: string;
}

interface FixedBarProps {
	navbarItems: BarItem[];
}

const iconsMap = {
	note: IconNote,
	events: IconEvents,
	search: IconUserSearch,
	notification: IconNotificationStatus,
	logo: IconLogo,
};

const Icon = ({ name }) => {
	const IconComponent = iconsMap[name] || null;

	if (!IconComponent) {
		return <span>Icon not found</span>;
	}

	return <IconComponent />;
};

const FixedBar: React.FC<FixedBarProps> = ({ navbarItems }) => {
	const [isOpenPrograms, setIsOpen] = useState<boolean>(false)

	return (
		<ST.BarContainer isVisible={false}>
			<List
				sx={{
					display: "flex",
					padding: "2px 12px",
				}}
			>
				{navbarItems.map((item) => (
					<ST.BarItem>
						<ST.LinkWrapper
							href={item.link}
							onClick={(e) => {
								if (item.icon === 'note') {
									e.preventDefault()
									setIsOpen(!isOpenPrograms)
								}
							}}
						>
							<Icon name={item.icon} />
							<ST.BarItemText
								style={{color: item.icon === 'note' && isOpenPrograms ? Colors.GREEN : "inherit"}}
							>
								{item.name}
							</ST.BarItemText>
						</ST.LinkWrapper>
					</ST.BarItem>
				))}
				<MenuAccordion
					items={HeaderStore.getProgramsMenu()}
					isVisible={isOpenPrograms}
				/>
			</List>
		</ST.BarContainer>
	);
};

export default FixedBar;
